import React, { PropsWithChildren, useEffect, useRef, useState } from 'react';
import Guid from "devextreme/core/guid";
import LicenceDataSource, { getSmartFetchData } from '../datasource/LicenceDataSource';
import { useAuthStore } from '../hooks/useAuthStore';
import dxDataGrid from "devextreme/ui/data_grid";
import dxPivotGrid from "devextreme/ui/pivot_grid";
import ReportFilter, { IReportParameters } from './ReportFilter';
import ReportGrid from './ReportGrid';
import ReportChart from './ReportChart';
import ReportForm from './ReportForm';
import ReportFormPreparer from '../utils/ReportFormPreparer';
import { LoadPanel } from 'devextreme-react/load-panel';
import ReportPivot from './ReportPivot';
import {Toolbar as RealToolbar} from 'devextreme-react/toolbar';
import ExporterToExcel from '../utils/ExporterToExcel';
import ExporterToPdf from '../utils/ExporterToPdf';
import dxChart from "devextreme/viz/chart";
import dxForm from "devextreme/ui/form";
import TabPanel, { Item} from 'devextreme-react/tab-panel';
import { setGlobalCurrReportParameters } from '../utils/GlobalProps';
import { IReportOneUIComponent, ReportParts, TypeOfReportParts } from '../models/ReportTypes';
import FillLayout from '../utils/FillLayout';
import ReactDOMServer from 'react-dom/server';
import ShowHider from './ShowHider';
import { isMobileDevice } from "../utils/DeviceDetect";
import ErrorLine from './ErrorLine';
import ExtractorDataGridOptions from '../utils/ExtractorDataGridOptions';
import DropDownUserReportComponentList, { CustomComponentDefauldId } from './DropDownUserReportComponentList';
import { isArray, ObjectUtils } from '../utils/ObjectUtils';
import ReshapeDataSource from '../datasource/ReshapeDataSource';
import RefUtils from '../utils/RefUtils';


export interface IReportGroupComponents {
    position: "header" | "main" | "footer";
    dataStore: Array<Object>;
    components: Array<IReportOneUIComponent>;
}
export interface IReport {
    title: string;
    reportParameters: IReportParameters;
    groupComponents: Array<IReportGroupComponents>;
}
export interface IReportViewProps{
    reportId: any;
    autoBuildReport?: boolean;
    exportFormat?: string;
    isDashBoard?: boolean;
    exportFileName?: string;
}


interface IReportViewStructure {
    Id: any,
    Filter: any, Layout: any,
    MainReportData: object, HeaderReportData: object, FooterReportData: object,
    MainBandComponents: any[], HeaderBandComponents: any[], FooterBandComponents: any[],
    DefaultMainBandComponents: any[], DefaultHeaderBandComponents: any[], DefaultFooterBandComponents: any[],
    CustomComponentId: any,
    FuncCanSetupCustomComponent: any,
}

type ReportViewStructureParam = keyof IReportViewStructure;

enum ReportViewStructure {
    Id = "Id",
    Filter = "Filter",
    Layout = "Layout",
    MainReportData = "MainReportData",
    HeaderReportData = "HeaderReportData",
    FooterReportData = "FooterReportData",
    MainBandComponents = "MainBandComponents",
    HeaderBandComponents = "HeaderBandComponents",
    FooterBandComponents = "FooterBandComponents",
    DefaultMainBandComponents = "DefaultMainBandComponents",
    DefaultHeaderBandComponents = "DefaultHeaderBandComponents",
    DefaultFooterBandComponents = "DefaultFooterBandComponents",
    CustomComponentId = "CustomComponentId",
    FuncCanSetupCustomComponent = "FuncCanSetupCustomComponent",
}
;


const ReportView = (reportViewProps:IReportViewProps) => {
    const authStore = useAuthStore();
    const [isLoading, setIsLoading] = useState(true);
    const [errorText, setErrorText] = useState("");
    const [reportItem, setReportItem] = useState({});

    const [reportFilter, setReportFilter] = useState(null);
    const [reportLayout, setReportLayout] = useState(null);
    let reportLayoutRootElementId = null;

    const [reportPrepared, setReportPrepared] = useState(false);
    const [reportRunDate, setReportRunDate] = useState(new Date());
    const [reportFilterParameters, setReportFilterParameters] = useState({});
    const [reportFilterVisibilityParameters, setReportFilterVisibilityParameters] = useState([]);

    const [reportMainReportData, setMainReportData] = useState({});
    const [reportHeaderReportData, setHeaderReportData] = useState({});
    const [reportFooterReportData, setFooterReportData] = useState({});
    const [reportRecordSet1, setReportRecordSet1] = useState({});
    const [reportRecordSet2, setReportRecordSet2] = useState({});
    const [reportRecordSet3, setReportRecordSet3] = useState({});
    const [reportRecordSet4, setReportRecordSet4] = useState({});
    const [reportRecordSet5, setReportRecordSet5] = useState({});
    const [reportRecordSet6, setReportRecordSet6] = useState({});
    const [reportRecordSet7, setReportRecordSet7] = useState({});

    const [reportMainBandComponents, setReportMainBandComponents] = useState([]);
    const [reportHeaderBandComponents, setReportHeaderBandComponents] = useState([]);
    const [reportFooterBandComponents, setReportFooterBandComponents] = useState([]);
    const [loadPanelVisible, setLoadPanelVisible] = useState(false);
    const [lastMessage, setLastMessage] = useState("");
    const [drawerOpened, setDrawerOpened] = useState(true);
    const [viewTypeMode, setViewTypeMode] = useState(reportViewProps.isDashBoard == true ? 0 : 1);// 0-onepage, 1-tabpanel
    const [exportToPdfVisible, setExportToPdfVisible] = useState(true);
    const [exportToExcelVisible, setExportToExcelVisible] = useState(true);

    const onCanSetupCustomComponent = (dataFromChild) => {
        currentReportSetOption(ReportViewStructure.FuncCanSetupCustomComponent, dataFromChild[1]);
    };

    const [currentReportDataSource, setCurrentReportDataSource] = useState(new ReshapeDataSource({key: ["Id"],}));

    const currentReport = (): IReportViewStructure => {
        if (currentReportDataSource.itemList.length == 0) {
            const item = Object.assign({
                Id: null,
                Filter: null, Layout: null,
                MainReportData: {}, HeaderReportData: {}, FooterReportData: {},
                MainBandComponents: [], HeaderBandComponents: [], FooterBandComponents: [],
                DefaultMainBandComponents: [], DefaultHeaderBandComponents: [], DefaultFooterBandComponents: [],
                CustomComponentId: null, 
                FuncCanSetupCustomComponent: null,
            }, {});
            currentReportDataSource.insert(item);
        }
        const item = currentReportDataSource.itemList[0];
        return item;
    }
//    const currentReportSetOption = (name: ReportViewStructureParam, value: any) => {
    const currentReportSetOption = (name: ReportViewStructureParam, value: any) => {
        currentReport()[name] = value;
        if (name == ReportViewStructure.CustomComponentId) {
            localStorage.setItem(`ReportViewStructure.CustomComponentId(${currentReportGetOption(ReportViewStructure.Id) || (new Guid().toString())})`, value);
        }

        currentReportDataSource.update(currentReport())
    }
    const currentReportGetOption = (name) => {
        let value = currentReport()[name];
        if (!value && name == ReportViewStructure.CustomComponentId) {
            value = localStorage.getItem(`ReportViewStructure.CustomComponentId(${currentReportGetOption(ReportViewStructure.Id) || (new Guid().toString())})`) || CustomComponentDefauldId;
        }
        return value;
    }


    const fetchCallbackReportItem = async () => {
        currentReportDataSource.clear();

        setErrorText("");
        try {
            const response = await getSmartFetchData(
                {
                    authStore: authStore,
                    //                url: LicenceDataSource.reportUrl + "/" + reportId,
                    url: "api/reports" + "/" + reportViewProps.reportId,

                    config: {},
                }
            );

            const item = response.data;

            let filter = null;
            try {
                filter = JSON.parse(item["Filter"]["JsonObject"]);
                filter = ReportFormPreparer.formPrepare(
                    {
                        items: JSON.parse(JSON.stringify(filter || []))
                    },
                    authStore
                )["items"];
            }
            catch {
            }
            setReportFilter(filter);
            let layout = null;
            try {
                layout = item["Layout"]["Layout"];
            }
            catch {
            }
            setReportLayout(layout);

            fillAllReportBandComponents(item);
            setReportItem(item);
        }
        catch (err) {
            setErrorText(err.message);
        }
        setIsLoading(false);
    }// it's OK
    useEffect(
        () => {
            fetchCallbackReportItem();
        }
        ,
        []
    );

    const getStoreUrl = (SqlId, tmpUrlSearch) => {
        return LicenceDataSource.reportDataUrl + "/" + SqlId + "/?" + tmpUrlSearch;

    }

    const getStoreData = async (url) => {
        const response = await getSmartFetchData(
            {
                authStore: authStore,
                url: url,
                config: {},
            }
        );
        const data = response.data;
        return data;
    }


    const getReportItemComponentByName = (reportItem, name) => {
        let localReportObject = null;
        try {
            localReportObject = JSON.parse(reportItem[name]["JsonObject"]);
        }
        catch { }
        return localReportObject;
    }

    const fillAllReportBandComponents = (reportItem) => {
        const mainComp = getReportItemComponentByName(reportItem, "MainComponent") || [];
        const headerComp = getReportItemComponentByName(reportItem, "HeaderComponent") || [];
        const footerComp = getReportItemComponentByName(reportItem, "FooterComponent") || [];
//        setReportMainBandComponents(mainComp);
//        setReportHeaderBandComponents(headerComp);
//        setReportFooterBandComponents(footerComp);

        currentReportSetOption(ReportViewStructure.Id, reportItem["Id"]);
        currentReportSetOption(ReportViewStructure.MainBandComponents, mainComp);
        currentReportSetOption(ReportViewStructure.HeaderBandComponents, headerComp);
        currentReportSetOption(ReportViewStructure.FooterBandComponents, footerComp);
        currentReportSetOption(ReportViewStructure.DefaultMainBandComponents, mainComp);
        currentReportSetOption(ReportViewStructure.DefaultHeaderBandComponents, headerComp);
        currentReportSetOption(ReportViewStructure.DefaultFooterBandComponents, footerComp);
        fillCurrentBandComponentsStructureByCustomComponentId(currentReportGetOption(ReportViewStructure.CustomComponentId));
//        fillCurrentBandComponentsStructureByCustomComponentId(CustomComponentDefauldId);

        const allItems = headerComp.concat(mainComp).concat(footerComp);
        setExportToPdfVisible(
            allItems.filter(item => {
                return item.type == "dxForm"
                    || item.type == "dxPivotGrid"
                    || item.type == "dxPivotGridWithChart"
            }).length == 0);

    }

    const fillAllReportDataStore = async (parameters) => {
        let search = new URLSearchParams(parameters).toString();
/*
        setMainReportData(await getStoreData(getStoreUrl(reportItem["MainSqlId"] || LicenceDataSource.defaultGuid, search)));
        setHeaderReportData(await getStoreData(getStoreUrl(reportItem["HeaderSqlId"] || LicenceDataSource.defaultGuid, search)));
        setFooterReportData(await getStoreData(getStoreUrl(reportItem["FooterSqlId"] || LicenceDataSource.defaultGuid, search)));
*/
        setReportRecordSet1(await getStoreData(getStoreUrl(reportItem["Sql1Id"] || LicenceDataSource.defaultGuid, search)));
        setReportRecordSet2(await getStoreData(getStoreUrl(reportItem["Sql2Id"] || LicenceDataSource.defaultGuid, search)));
        setReportRecordSet3(await getStoreData(getStoreUrl(reportItem["Sql3Id"] || LicenceDataSource.defaultGuid, search)));
        setReportRecordSet4(await getStoreData(getStoreUrl(reportItem["Sql4Id"] || LicenceDataSource.defaultGuid, search)));
        setReportRecordSet5(await getStoreData(getStoreUrl(reportItem["Sql5Id"] || LicenceDataSource.defaultGuid, search)));
        setReportRecordSet6(await getStoreData(getStoreUrl(reportItem["Sql6Id"] || LicenceDataSource.defaultGuid, search)));
        setReportRecordSet7(await getStoreData(getStoreUrl(reportItem["Sql7Id"] || LicenceDataSource.defaultGuid, search)));

        currentReportSetOption(ReportViewStructure.MainReportData, await getStoreData(getStoreUrl(reportItem["MainSqlId"] || LicenceDataSource.defaultGuid, search)));
        currentReportSetOption(ReportViewStructure.HeaderReportData, await getStoreData(getStoreUrl(reportItem["HeaderSqlId"] || LicenceDataSource.defaultGuid, search)));
        currentReportSetOption(ReportViewStructure.FooterReportData, await getStoreData(getStoreUrl(reportItem["FooterSqlId"] || LicenceDataSource.defaultGuid, search)));

    }

    const reportVisibilityParametersJsonObject = [
        {
            "type": "dxDataGrid",
            "title": "Параметры",
            "component":
            {
                "allowColumnReordering": false,
                "showColumnHeaders": false,
                "showColumnLines": true,
                "showRowLines": true,
                "showBorders": true,
                "headerFilter": { "visible": false},
                "groupPanel": { "visible": false },
                "toolbar": { "visible": false },
                "defaultColumns":
                    [
                        { "caption": "Параметр", "dataField": "labelText", "alignment": "right", "width":"50%", "allowSorting": false, "cssClass": "report-header-data-cell-title_" },
                        { "caption": "Значение", "dataField": "text", "alignment": "left", "width": "50%", "allowSorting": false, "cssClass": "report-header-data-cell-title_" },
                    ]
            }        
        }
    ];

    const onRunReport = async (allparameters: IReportParameters) => {
        {
            if (loadPanelVisible) return;
            clearCurrRefsArray();
            const parameters = allparameters.reportFilterParameters;
            setLastMessage("");
            setReportPrepared(false);
            setReportFilterParameters(parameters);
            setReportFilterVisibilityParameters(allparameters.reportFilterVisibilityParameters);
            setLoadPanelVisible(true);
            //GlobalProps.
            setGlobalCurrReportParameters(allparameters.reportFilterFullParameters);
//            fillCurrentBandComponentsStructureByCustomComponentId(currentReportGetOption(ReportViewStructure.CustomComponentId));
//            fillCurrentBandComponentsStructureByCustomComponentId(CustomComponentDefauldId);

            try {
                await fillAllReportDataStore(parameters);
                setReportRunDate(new Date());
                setReportPrepared(true);
                const funcCanSetupCustomComponent = currentReportGetOption(ReportViewStructure.FuncCanSetupCustomComponent);
                if (funcCanSetupCustomComponent) {
                    funcCanSetupCustomComponent(localStorage.getItem("showSetupAtMainIsAuthToolbar") == "true" && authStore.user?.IsAdmin);
                }
            }
            catch(e) {
                setLastMessage(e.message);
            }
            finally {
                setLoadPanelVisible(false);
            }
        };
    }    

    const testProps = {
        headerFilter: {
            visible: false,
            allowSearch: false,
        },
        summary: {}
    }

    interface IReportUsedOneUIComponent extends IReportOneUIComponent{
        ref: React.MutableRefObject<any>,
        used: boolean
    }

    let currRefsArray: Array<IReportUsedOneUIComponent> = [];
    const cMaxRefCount = 20;
    for (let i = 0; i < cMaxRefCount; i++) {
        currRefsArray.push({ ref: useRef(null), used: false, type: null, title: "", component: null, reportPart: null, indexInReportPart: null  });
    }
    const clearCurrRefsArray = () => {
        currRefsArray.map(item => { item.used = false; item.type = null; item.title = ""; item.component = null; item.reportPart = null; item.indexInReportPart = null; })
    }

    const getNextRef = (type: any, title: any, reportPart: TypeOfReportParts, indexInReportPart: number) => {
        const elem = currRefsArray.find(item => item.used == false);
        if (elem) {
            elem.used = true;
            elem.type = type;
            elem.title = title;
            elem.indexInReportPart = indexInReportPart;
            elem.reportPart = reportPart;
            return elem.ref;
        }
        return null;
    }
    const currUsedRefsArray = (): Array<IReportOneUIComponent> => {
        let res = currRefsArray.map(item => {
            if (item.used) {
                let component;
                if (item.type == "dxDataGrid") {
                    component = RefUtils.dataGridInstance(item.ref);
                }
                else if (item.type == "dxPivotGrid") {
                    component = RefUtils.pivotInstance(item.ref);
                }
                else if (item.type == "dxChart") {
                    component = RefUtils.chartInstance(item.ref);
                }
                return {
                    title: item.title,
                    component: component,
                    type: item.type,
                    indexInReportPart: item.indexInReportPart,
                    reportPart: item.reportPart,
                }
            }
        });
        return res;
    }

    const exportCurrReportToExcel = () => {
        exportCurrReportTo(reportItem["Name"], "xlsx");
    }
    const exportCurrReportToPdf = () => {
        exportCurrReportTo(reportItem["Name"], "pdf");
    }

    const exportCurrReportTo = (reportName: string, exportFormat: string) => {
//        reportName = reportName || reportItem["Name"];
        exportFormat = (exportFormat || "").toLowerCase();
        if (exportFormat == "pdf") {
            if (reportLayout) {
                ExporterToPdf.htmlToPdf(reportName, reportLayoutRootElementId);
            }
            else {
                ExporterToPdf.exportToPdf(reportName, currUsedRefsArray());
            }
        }
        else if (exportFormat == "xlsx" || exportFormat == "xls" || exportFormat == "excel") {
            ExporterToExcel.exportToExcel(reportName, currUsedRefsArray());
        }
    }

    const reportBandComponent = (item: any, dataStore: any, defaultTitle: any, reportPart: TypeOfReportParts, indexInReportPart: number) => {
        let component;
        if (!reportPrepared) return component;
        const reportName = reportItem["Name"];
//        let clonedItemComponent = item.component;
        let clonedItemComponent = JSON.parse(JSON.stringify(item.component));
        const title = item.title || defaultTitle;
        if (item.type == "dxDataGrid") {
            component = <ReportGrid
                reportName={reportName}
                dataStore={dataStore}
                runDate={reportRunDate}
                innerRef={getNextRef("dxDataGrid", title, reportPart, indexInReportPart)}
                {...clonedItemComponent}
                />
        }
        else if (item.type == "dxChart") {
            component = <ReportChart
//                title={reportName}
                dataStore={dataStore}
                runDate={reportRunDate}            
                innerRef={getNextRef("dxChart", title, reportPart, indexInReportPart)}
                {...clonedItemComponent}
            />
        }
        else if (item.type == "dxForm") {
            clonedItemComponent.items = ReportFormPreparer.formPrepare(clonedItemComponent, authStore)["items"];
            let dataObject = (dataStore || [])[0] || {};
            const reportInfo = {
                filterParameters: reportFilterParameters,
                reportName: reportName,
            }
            dataObject["reportInfo"] = reportInfo;
            component = <ReportForm
                dataStore={dataObject}
                runDate={reportRunDate}
                {...clonedItemComponent}
            />
        }
        else if ((item.type == "dxPivotGrid") || (item.type == "dxPivotGridWithChart")) {
            clonedItemComponent["dataSource"]["store"] = dataStore;
            const showChart = item.type == "dxPivotGridWithChart"
            const chartInnerRef = showChart ? getNextRef("dxChart", title, reportPart, indexInReportPart) : undefined;
            component = <ReportPivot
                reportName={reportName}
                showChart={showChart}
                runDate={reportRunDate}
                innerRef={getNextRef("dxPivotGrid", title, reportPart, indexInReportPart)}
                chartInnerRef={chartInnerRef}
                {...clonedItemComponent}
            />
        }
        console.log(component, ReactDOMServer.renderToStaticMarkup(component));
        return component;
    }

    const renderReportBandComponents = (className: any, bandComponents: any, reportData: any, title: any, reportPart: TypeOfReportParts) => {
        if (bandComponents.length == 0) return <></>;
        let res = <>
                {
                    bandComponents.map((item, index) => {
                        const key = new Guid().toString();
                        if (viewTypeMode == 1) {
                            return (
                                <Item title={item.title || title} key={key}>
                                    <div className="report-band">
                                        {
                                            reportBandComponent(item, reportData, title, reportPart, index)
                                        }
                                    </div>
                                </Item>
                            )
                        }
                        else {
                            return (
                                <div
                                    className={className + (reportViewProps.isDashBoard == true ? "_dashboard" : "")}
                                    key={key}
                                >
                                    <div className="report-band">
                                        {
                                            reportBandComponent(item, reportData, title, reportPart, index)
                                        }
                                    </div>
                                </div>
                            )
                        }
                    })
                }
            </>
            ;
        return res.props.children;
    }

    const renderReportLayoutContainer = () => {
        let layout =
                    `
                    <div style="background-color:red;">
                        {{ this.HeaderData[0].UserName}}
                    </div>
                    <div style="background-color:blue;">
                        {{
                            ()=>{
                                let s = "";
                                const record = this.HeaderData[0];
                                for (let key in record){
                                    s = s + key + "=" + record[key] + ";";
                                }
                                return s;
                            }
                        }}
                    </div>
                    `;
        reportLayoutRootElementId = new Guid().toString();
        let contextObj = {
            Id: reportLayoutRootElementId,
            RecordSetHeader: currentReportGetOption(ReportViewStructure.HeaderReportData),// reportHeaderReportData,
            RecordSetMain: currentReportGetOption(ReportViewStructure.MainReportData),// reportMainReportData,
            RecordSetFooter: currentReportGetOption(ReportViewStructure.HeaderReportData), //reportFooterReportData,
            RecordSet1: reportRecordSet1,
            RecordSet2: reportRecordSet2,
            RecordSet3: reportRecordSet3,
            RecordSet4: reportRecordSet4,
            RecordSet5: reportRecordSet5,
            RecordSet6: reportRecordSet6,
            RecordSet7: reportRecordSet7,
            GetHeaderComponentById: (id) => {
                const reportHeaderBandComponents = currentReportGetOption(ReportViewStructure.HeaderBandComponents);
                if (!reportHeaderBandComponents) return;
                let item = reportHeaderBandComponents.find(elem => elem["id"] == id);
                if (!item) {
                    item = reportHeaderBandComponents[0];
                }
                if (!item) return;
                const result = reportBandComponent(item, currentReportGetOption(ReportViewStructure.HeaderReportData), item["title"], null, null);
                return result;
            }                
        };
        layout = reportLayout;
        const result = FillLayout(
            {
                layout: layout,
                context: contextObj,
            });
        return result;
    }

    const onTabPanelInitialized = (args) => {
        let comp = args.component;// as dxTabPanel;
        comp.option("selectedIndex", 2);
    }
    const onTabPanelTitleClick = (args) => {
        let comp = args.component;// as dxTabPanel;
    }
    const onTabPanelOptionChanged = (args) => {
        let comp = args.component;// as dxTabPanel;
        if (args.name === 'selectedIndex') {
            if (args.value == 0) {
                comp.option("selectedIndex", args.previousValue);
//                args.value = args.previousValue;
            }
        }
    }
    const onTabPanelContentReady = (args) => {
        let comp = args.component;// as dxTabPanel;
        comp.focus();
    }    
    
    const renderReportContainer = () => {
        clearCurrRefsArray();
        if (reportLayout) {
            return renderReportLayoutContainer();
        }
        /////////////////////////
        if (viewTypeMode == 1) {
            return (
                <div className="report-data-container">
                    <TabPanel
                        elementAttr={{ class: "report-view-tabpanel" }}
                        height="100%"
                        width="100%"
                        deferRendering={false}
                        repaintChangesOnly={true}
                        onInitialized={onTabPanelInitialized}
//                        onContentReady={onTabPanelContentReady}
//                        onTitleClick={onTabPanelTitleClick}
//                        onOptionChanged={onTabPanelOptionChanged}
                        swipeEnabled={false}
                    >
                        {
                            renderReportBandComponents("report-header-data-tabpanel", currentReportGetOption(ReportViewStructure.HeaderBandComponents), currentReportGetOption(ReportViewStructure.HeaderReportData), '\xA0\xA0\xA0\xA0\xA0\xA0\xA0\xA0\xA0' + "Заголовок", ReportParts.Header)
                        }
                        {
                            renderReportBandComponents("report-parameters-data-tabpanel", reportVisibilityParametersJsonObject, reportFilterVisibilityParameters, "Параметры", ReportParts.Parameters)
                        }
                        {
                            renderReportBandComponents("report-parameters-data-tabpanel", currentReportGetOption(ReportViewStructure.MainBandComponents), currentReportGetOption(ReportViewStructure.MainReportData), "Данные", ReportParts.Data)
                        }
                        {
                            renderReportBandComponents("report-footer-data-tabpanel", currentReportGetOption(ReportViewStructure.FooterBandComponents), currentReportGetOption(ReportViewStructure.FooterReportData), "Подвал", ReportParts.Footer)
                        }
                    </TabPanel>
                </div>
            )
        }
        else {
            return (
                <div className="report-data-container">
                    {
                        renderReportBandComponents("report-header-data", currentReportGetOption(ReportViewStructure.HeaderBandComponents), currentReportGetOption(ReportViewStructure.HeaderReportData), "Заголовок", ReportParts.Header)
                    }
                    {
                        renderReportBandComponents("report-parameters-data", reportVisibilityParametersJsonObject, reportFilterVisibilityParameters, "Параметры", ReportParts.Parameters)
                    }
                    {
                        //                        renderReportBandComponents("report-main-data", currentReportGetOption(ReportViewStructure.MainBandComponents), reportMainReportData, "Данные", ReportParts.Data)
                        renderReportBandComponents("report-main-data", currentReportGetOption(ReportViewStructure.MainBandComponents), currentReportGetOption(ReportViewStructure.MainReportData), "Данные", ReportParts.Data)

                    }
                    {
                        renderReportBandComponents("report-footer-data", currentReportGetOption(ReportViewStructure.FooterBandComponents), currentReportGetOption(ReportViewStructure.FooterReportData), "Подвал", ReportParts.Footer)
                    }
                </div>
            )
        }
    }

    const loadPanelPosition = { of: ".body" };

    const reportFilterContainerRef = useRef(null);

    const finalComponent = () => {
        const reportViewContainerId = "report-view-container";
        return (
            <div className="report-view-container" id={reportViewContainerId}>
                <LoadPanel
                    shadingColor="rgba(0,0,0,0.4)"
                    position={loadPanelPosition}
                    onHiding={null}
                    visible={loadPanelVisible}
                    showIndicator={true}
                    shading={true}
                    showPane={true}
                    closeOnOutsideClick={false}
                />
                {
                    (lastMessage == "") && reportPrepared && reportViewProps.isDashBoard != true &&
                    <ShowHider
                        targetref={reportFilterContainerRef}
                        defaultValue={!isMobileDevice}
                    />
                }
                <div
                    ref={reportFilterContainerRef}
                    className={"report-filter-container"
                        + (
                        (reportViewProps.autoBuildReport == true && reportViewProps.isDashBoard == true)
                                ? "_dashboard"
                                : ""
                        )
                    }
                >
                    <ReportFilter
                        defaultFilter={reportItem["Filter"]}
                        filterItems={reportFilter}
                        runReport={onRunReport}
                        reportName={reportItem["Name"]}
                        reportFilterExtraParams={
                            {
                                reportId: reportItem["Id"],
                            }
                        }
                        autoBuildReport={reportViewProps.autoBuildReport}
                    />
                    <div
                        className="report-control"
                    >
                        <DropDownUserReportComponentList
                            defaultValue={currentReportGetOption(ReportViewStructure.CustomComponentId)}
                            reportId={reportItem["Id"]}
                            //componentId={reportItem["MainComponentId"]}
                            onSelectedItemChange={onChangeCustomComponent}
                            getCurrentStructure={getCurrentStructure}
                            onCanSetupState={onCanSetupCustomComponent}
                        />
                    </div>
                    {
                        (lastMessage == "") && reportPrepared &&
                        <div
                            className="report-control"
//                            style={{ width: "100%" }}
                        >
                                <RealToolbar
                                    className="report-control-band-2"
                                    items={toolbarItems2()}
                                    visible={true}
                                />
                                <RealToolbar
                                    className="report-control-band-1"
                                    items={toolbarItems()}
                                    visible={true}
                                />

                        </div>
                    }
                </div>
                {
                    (lastMessage == "") && reportPrepared && renderReportContainer()
                }
                {
                    (lastMessage != "") && <div> {lastMessage} </div>
                }
                {
                    (lastMessage == "") && reportPrepared &&
                    reportViewProps.autoBuildReport && reportViewProps.exportFormat &&
                    <img
                        hidden={true}
                        src=""
                        onError={
                            (e) => setTimeout(
                                () => 
                                        exportCurrReportTo(
                                            reportViewProps.exportFileName || reportViewProps.reportId,
                                            reportViewProps.exportFormat
                                        )
                                        , 1000)
                        }
                    />
                }

            </div>
            )
    }

    const onChangeCustomComponent = async (data) => {
        await fillCurrentBandComponentsStructureByCustomComponentId(data?.Id || CustomComponentDefauldId);
    }

    const getCustomComponentUrl = (id) => {
        return "/api/main/customcomponent" + "/" + id;
    }

    const getReportCustomComponentJsonObjectById = async (id) => {
        const data = await getStoreData(getCustomComponentUrl(id));
        let localReportObject = null;
        try {
            localReportObject = JSON.parse(data["JsonObject"]);
        }
        catch { }
        return localReportObject;
    }

    const fillCurrentBandComponentsStructureByCustomComponentId = async (customComponentId) => {
        console.log(`Call fillCurrentBandComponentsStructureByCustomComponentId(${customComponentId})`);
        if (!customComponentId) {
//            customComponentId = CustomComponentDefauldId;
        }
        const components = currUsedRefsArray();
        const setOptionDefaultColumns = (reportBandComponents0: any[], reportPart: TypeOfReportParts) => {
            let reportBandComponents = [...reportBandComponents0];
            for (let item of components) {
                if (!item) continue;
                if (!item.component) continue;
                if (item.component["NAME"] != "dxDataGrid") continue;
                if (item.reportPart != reportPart) continue;
                const rmo = reportBandComponents[item.indexInReportPart].component;
                const defaultColumns = rmo["defaultColumns"];
                if (!defaultColumns) continue;
                const comp: dxDataGrid = item.component as dxDataGrid;
                //comp.option("defaultColumns", defaultColumns);
                ObjectUtils.evalAllProperty(defaultColumns, defaultColumns, false, 1, 4);
                comp.option("columns", defaultColumns);
            }
        }
        currentReportSetOption(ReportViewStructure.CustomComponentId, customComponentId);
        localStorage.setItem("ReportViewStructure.CustomComponentId", customComponentId);
        if (customComponentId == CustomComponentDefauldId) {
            //getReportItemComponentByName(reportItem, "MainComponent")
            const mainComp = getReportItemComponentByName(reportItem, "MainComponent") || [];
            const headerComp = getReportItemComponentByName(reportItem, "HeaderComponent") || [];
            const footerComp = getReportItemComponentByName(reportItem, "FooterComponent") || [];
            setOptionDefaultColumns(headerComp, ReportParts.Header);
            setOptionDefaultColumns(mainComp, ReportParts.Data);
            setOptionDefaultColumns(footerComp, ReportParts.Footer);
            currentReportSetOption(ReportViewStructure.MainBandComponents, mainComp);
            currentReportSetOption(ReportViewStructure.HeaderBandComponents, headerComp);
            currentReportSetOption(ReportViewStructure.FooterBandComponents, footerComp);
            return;
/*
            setOptionDefaultColumns([...currentReportGetOption(ReportViewStructure.DefaultHeaderBandComponents) || []], ReportParts.Header);
            setOptionDefaultColumns([...currentReportGetOption(ReportViewStructure.DefaultMainBandComponents) || []], ReportParts.Data);
            setOptionDefaultColumns([...currentReportGetOption(ReportViewStructure.DefaultFooterBandComponents) || []], ReportParts.Footer);
            currentReportSetOption(ReportViewStructure.MainBandComponents, [...currentReportGetOption(ReportViewStructure.DefaultMainBandComponents) || []]);
            currentReportSetOption(ReportViewStructure.HeaderBandComponents, [...currentReportGetOption(ReportViewStructure.DefaultHeaderBandComponents) || []]);
            currentReportSetOption(ReportViewStructure.FooterBandComponents, [...currentReportGetOption(ReportViewStructure.DefaultFooterBandComponents) || []]);
            return;
*/
        }

        const jsonObject = await getReportCustomComponentJsonObjectById(customComponentId);
//        ObjectUtils.evalAllProperty(jsonObject, jsonObject, false, 1, 4);

        setOptionDefaultColumns([...jsonObject["Header"] || []], ReportParts.Header);
        setOptionDefaultColumns([...jsonObject["Main"] || []], ReportParts.Data);
        setOptionDefaultColumns([...jsonObject["Footer"] || []], ReportParts.Footer);

        currentReportSetOption(ReportViewStructure.MainBandComponents, [...jsonObject["Main"] || []])
        currentReportSetOption(ReportViewStructure.HeaderBandComponents, [...jsonObject["Header"] || []])
        currentReportSetOption(ReportViewStructure.FooterBandComponents, [...jsonObject["Footer"] || []])
    }

    const updateColumnsPropertyCall = (obj: any, currColumns: any[]) => {
        let columnsCounter = -1;
        const updateColumnsProperty = (obj: any, currColumns: any[]) => {
            if (typeof obj !== "object") return;
            if (isArray(obj)) {
                for (let item of obj) {
                    updateColumnsProperty(item, currColumns);
                }
            }
            else {
                let applied = false;
                for (let key in obj) {
                    if (!applied) {
                        columnsCounter++;
                        //                    const currCol = currColumns.find(item => item[key] == obj[key]);
                        const currCol = currColumns.find(item => item["index"] == columnsCounter);
                        if (currCol) {
                            let tmpCol = {
                                visible: currCol["visible"],
                                visibleIndex: currCol["visibleIndex"],
                                visibleWidth: currCol["visibleWidth"],
                                groupIndex: currCol["groupIndex"],
                                filterValues: currCol["filterValues"],
                                filterType: currCol["filterType"],
                            }
//                            ObjectUtils.evalAllProperty(tmpCol, tmpCol, false, 1, 4);
                            obj["visible"] = tmpCol["visible"];
                            obj["visibleIndex"] = tmpCol["visibleIndex"];
                            obj["visibleWidth"] = tmpCol["visibleWidth"];
                            obj["width"] = tmpCol["visibleWidth"];
                            obj["groupIndex"] = tmpCol["groupIndex"];
                            obj["filterValues"] = tmpCol["filterValues"];
                            obj["filterType"] = tmpCol["filterType"];
                            /*
                            obj["visible"] = currCol["visible"];
                            obj["visibleIndex"] = currCol["visibleIndex"];
                            obj["visibleWidth"] = currCol["visibleWidth"];
                            obj["width"] = currCol["visibleWidth"];
                            obj["groupIndex"] = currCol["groupIndex"];
                            */
                        }
                        applied = true;
                    }
                    if (typeof obj[key] == "object" && key == "columns") {
                        updateColumnsProperty(obj[key], currColumns);
                    }
                }
            }
        }
        updateColumnsProperty(obj, currColumns);
    }

    const getCurrentStructure = () => {
        if (!((lastMessage == "") && reportPrepared)) {
            return null;
        }
        const components: Array<IReportOneUIComponent> = ExtractorDataGridOptions.getColumnsOfGrids(currUsedRefsArray());
        const richReportBandComponents = (reportBandComponents: any[], reportPart: TypeOfReportParts) => {
            for (let item of components) {
                if (!item) continue;
                if (!item.component) continue;
                if (item.component["NAME"] != "dxDataGrid") continue;
//                if (item.reportPart != ReportParts.Data) continue;
                if (item.reportPart != reportPart) continue;
                if (!item["currentColumns"]) continue;
                const currColumns = item["currentColumns"] || [];
                const rmo = reportBandComponents[item.indexInReportPart].component;
                const defaultColumns = rmo["defaultColumns"];
                updateColumnsPropertyCall(defaultColumns, currColumns);
                //rmo["defaultFilterValue"] = item["currentFilterValue"];
            }
            return reportBandComponents;
        }
        const res = {
            Header: richReportBandComponents([...currentReportGetOption(ReportViewStructure.HeaderBandComponents)], ReportParts.Header),
            Main: richReportBandComponents([...currentReportGetOption(ReportViewStructure.MainBandComponents)], ReportParts.Data),
            Footer: richReportBandComponents([...currentReportGetOption(ReportViewStructure.FooterBandComponents)], ReportParts.Footer),
        }
        
        return res;
    }
    const toolbarItems = () => {
        return [
            {
                widget: 'dxButton',
                location: 'before',
                visible: false,
                options: {
                    icon: 'menu',
                    onClick: () => setDrawerOpened(!drawerOpened),
                },
            },
            {
                widget: 'dxButton',
                location: 'before',
                visible: exportToExcelVisible,
                options: {
                    icon: 'xlsxfile',
                    hint: "Экспортировать всё в Excel",
                    onClick: () => exportCurrReportToExcel(),
                },
            },
            {
                widget: 'dxButton',
                location: 'before',
                visible: exportToPdfVisible,
                options: {
                    icon: 'pdffile',
                    hint: "Экспортировать всё в PDF",
                    onClick: () => exportCurrReportToPdf(),
                },
            },
        ];
    }

    const toolbarItems2 = () => {
        return [
            {
                widget: 'dxSelectBox',
//                location: 'before',
//                cssClass: "width-100-percent",
                options: {
                    hint: "Представление результатов",
                    onClick: () => exportCurrReportToPdf(),
                    dataSource: [
                        { id: 0, name: "На одной странице" },
                        { id: 1, name: "Разбивать по страницам" },
                    ],
                    displayExpr: "name",
                    valueExpr: "id",
                    value: viewTypeMode,
                    onValueChanged: (e) => {
                        setViewTypeMode(e.value)
                    },
                    width: "100%",
                },
            },
        ];
    }

    if (isLoading)
        return (
            <div> Ждите... </div>
        )
    else if ((errorText || "").trim())
        return (
            <ErrorLine
            errorText={errorText}
            type="error"
            />
        )
   else
        return finalComponent();

}


export default React.memo(ReportView);

